import api from './axios';

const formData = (fields, file) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (k === 'branchIds' && Array.isArray(v)) {
      fd.append('branchIds', JSON.stringify(v));
      return;
    }
    fd.append(k, v);
  });
  if (file) fd.append('file', file);
  return fd;
};

export const fetchServices = (params) =>
  api.get('/services', { params }).then((r) => r.data);

export const fetchServiceSuggestions = (params) =>
  api.get('/services/suggestions', { params }).then((r) => r.data);

export const createService = (fields, file) =>
  api
    .post('/services', formData(fields, file), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);

export const updateService = (id, fields, file) =>
  api
    .put(`/services/${id}`, formData(fields, file), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);

export const deleteService = (id) => api.delete(`/services/${id}`).then((r) => r.data);

export const fetchServiceHistory = (id) =>
  api.get(`/services/${id}/history`).then((r) => r.data);
